
import {mapGetters, mapMutations} from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtMortgageNew from '@/common/components/mvtmortgage/mvt-mortgage-new.vue';

export default {
    name: 'propertyMortgage',
    components: {
        mvtCollapse,
        mvtMortgageNew,
    },
    inject: ['$eventBus'],
    props: ['disableCollapse', 'options', 'isActive'],
    data() {
        return {
            description: '',
            showDataSource: null,
            isMounted: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
    },
    methods: {
        ...mapMutations('dpp', ['updateMortgagePerMonth', 'updateMonthTotal']),
        ...mapGetters('glb', ['getComplianceMethod']),
        needShowDataSource() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
        monthTotalChanged(val) {
            this.updateMonthTotal(val);
        },
        loanPerMonthChanged(val) {
            this.updateMortgagePerMonth(val);
        },
        updateDescription(text) {
            this.description = text;
        },
    },
    mounted() {
        this.isMounted = true;
        this.showDataSource = this.needShowDataSource();
    },
};
